import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import UploadSettings from "@presentation/components/job/components/UploadSettings";
import { SettingsTypeEnumSchema, SoftwareSettingsMetadata } from "@domain/schemas/BI";
import type { UploadDestination } from "@presentation/components/uploadDestination/UploadDestinationPickerDialog";

export const UploadSettingsDialog: React.FC<{
  settingsType: SettingsTypeEnumSchema;
  initialDestination?: Partial<UploadDestination>;
  onUploadSuccess: (uploadedSettings: SoftwareSettingsMetadata) => void;
  onCancel: () => void;
}> = ({ settingsType, initialDestination, onUploadSuccess, onCancel }) => {
  return (
    <Dialog title="Upload Settings" onClose={onCancel} width={600}>
      <UploadSettings settingsType={settingsType} initialDestination={initialDestination} onUploadSuccess={onUploadSuccess} />
      <DialogActionsBar>
        <Button type="button" aria-label="Close upload dialog" onClick={onCancel}>
          Close
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};
